import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/assets/js/watermark.js'

// import request from './assets/js/request.js';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
const app = createApp(App)




import * as ElementPlusIconsVue from '@element-plus/icons-vue'
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }





// 将 Axios 实例挂载到 Vue 实例的原型上
// app.config.globalProperties.$axios = request;

app.use(ElementPlus)
app.use(Antd)
app.use(store).use(router).mount('#app')
